import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnswerBehavior, Question } from 'src/app/core/models/questionnaire.model';
import { AgentClientsService } from 'src/app/core/services/agent-clients.service';
import { QuestionAnswer } from '../question/question.component';

@Component({
  selector: 'app-question-multi-select',
  templateUrl: './question-multi-select.component.html',
  styleUrls: ['./question-multi-select.component.scss'],
})
export class QuestionMultiSelectComponent implements OnInit {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  value: string[] = [];
  blockMessage: string | null = null;

  constructor(private agentClientsService: AgentClientsService) {}

  ngOnInit(): void {
    const answerValue = this.question?.answer?.value;
    if (answerValue && typeof answerValue === 'string') {
      this.value = answerValue
        .split(',')
        .map((v) => v.trim())
        .filter((v) => v.length > 0);
    }

    this.change();
  }

  change() {
    setTimeout(() => {
      const val = this.checkValid();

      this.question.isValid = val;

      this.evaluateAnswerBehavior();

      this.changeAnswer.next({
        answer: {
          value: this.value.join(', '),
          addtional_information: { array: this.value },
        },
        question: this.question,
      });
    }, 10);
  }

  checkValid(): boolean {
    if (this.question.configuration.required) {
      return this.value.length > 0;
    } else {
      return true;
    }
  }

  private evaluateAnswerBehavior(): void {
    const behaviors: AnswerBehavior[] | undefined =
      this.question.configuration?.answer_behavior;
    if (!behaviors?.length) {
      this.blockMessage = null;
      return;
    }

    const isAgent = this.agentClientsService.isAgentSession();

    const matched = behaviors.find(
      (b) => b.agent === isAgent && this.value.includes(b.answerValue)
    );

    if (matched?.block) {
      this.blockMessage = matched.message;
      this.question.isValid = false;
      this.question.messageError = matched.message;
      this.question.isBlockedByAnswerBehavior = true;
    } else {
      this.blockMessage = null;
      this.question.isBlockedByAnswerBehavior = false;
    }
  }
}
